<template>
  <div class="promotion-list" v-loading="loading">
    <div class="promotion-top">
      <!--2023土地推介专场-->
      <span class="title">{{ fiveYear }}土地推介专场</span>
      <span class="line"></span>
      <!--卡片-->
      <div class="card-content">
        <div
          @click="openCentralYunnan(fiveData[0])"
          class="card-top card-top-left"
        >
          <div class="bg"></div>
          <img
            style="width: 100%; height: 100%"
            :src="imageAddress(fiveData[0])"
            alt=""
          />
          <div class="card-title">
            {{ fiveData[0] ? testVerify(fiveData[0]) : "敬请期待..." }}
          </div>
        </div>
        <div
          @click="openCentralYunnan(fiveData[1])"
          class="card-top card-top-right"
        >
          <div class="bg"></div>
          <img
            style="width: 100%; height: 100%"
            :src="imageAddress(fiveData[1])"
            alt=""
          />
          <div class="card-title">
            {{ fiveData[1] ? testVerify(fiveData[1]) : "敬请期待..." }}
          </div>
        </div>
      </div>
      <!--卡片-->
      <div class="card-content card-content-bottom">
        <div @click="openCentralYunnan(fiveData[2])" class="card card1">
          <div class="bg"></div>
          <img
            style="width: 100%; height: 100%"
            :src="imageAddress(fiveData[2])"
            alt=""
          />
          <div class="card-title">
            {{ fiveData[2] ? testVerify(fiveData[2]) : "敬请期待..." }}
          </div>
        </div>
        <div @click="openCentralYunnan(fiveData[3])" class="card card2">
          <div class="bg"></div>
          <img
            style="width: 100%; height: 100%"
            :src="imageAddress(fiveData[3])"
            alt=""
          />
          <div class="card-title">
            {{ fiveData[3] ? testVerify(fiveData[3]) : "敬请期待..." }}
          </div>
        </div>
        <div @click="openCentralYunnan(fiveData[4])" class="card card3">
          <div class="bg"></div>
          <img
            style="width: 100%; height: 100%"
            :src="imageAddress(fiveData[4])"
            alt=""
          />
          <div class="card-title">
            {{ fiveData[4] ? testVerify(fiveData[4]) : "敬请期待..." }}
          </div>
        </div>
      </div>
    </div>
    <!--往届土地推介专场查询列表-->
    <div class="promotion-bottom">
      <!--往届土地推介专场-->
      <span class="title title-go">往届土地推介专场</span>
      <span class="line"></span>
      <div class="monitor-content">
        <div class="monitor-year monitor-top">
          <div class="year">行政区划:</div>
          <ul
            class="year-content"
            :class="administrationData ? 'develop-away' : 'develop-up'"
          >
            <li
              @click="administrationSelect(index, item)"
              :class="administrationIndex === index ? 'navigation-select' : ''"
              v-for="(item, index) in administration"
              :key="index"
              class="year-item"
            >
              {{ item.label }}
            </li>
          </ul>
          <i
            @click="administrationDevelop"
            class="filter"
            :class="administrationIcon"
          ></i>
        </div>
        <div class="monitor-year">
          <div class="year">年份:</div>
          <ul
            class="year-content"
            :class="developData ? 'develop-away' : 'develop-up'"
          >
            <li
              @click="navigationSelect(index, item)"
              :class="navigationIndex === index ? 'navigation-select' : ''"
              v-for="(item, index) in monitorList"
              :key="index"
              class="year-item"
            >
              {{ item }}
            </li>
          </ul>
          <i @click="develop" class="filter" :class="developIcon"></i>
        </div>
      </div>
    </div>
    <!--往届土地推介专场列表-->
    <div class="list-content">
      <div
        @click="openCentralYunnan(item)"
        class="list-content-item"
        v-for="(item, index) in listData"
        :key="index"
      >
        <img class="img-content" :src="item.url" alt="" />
        <div class="line-name">{{ item.name }}</div>
      </div>
      <div class="park-list-table-no-c-img" v-if="!listData.length">
        <img src="../../assets/images/common/1.png" alt="" />
      </div>
    </div>
    <!--分页-->
    <div class="page-box">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="page"
        :page-size.sync="rows"
        :page-sizes="[15, 30, 50, 100]"
        prev-text="上一页"
        next-text="下一页"
        layout=" prev, pager, next,total, jumper "
        :total="total"
        style="background-color: #ecf5ff"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import kunming02 from "@/assets/promotion/kunming02.png";
import quj02 from "@/assets/promotion/qujing02.png";
import yux02 from "@/assets/promotion/yuxi02.png";
import bao02 from "@/assets/promotion/baoshang02.png";
import lij02 from "@/assets/promotion/lijiang02.png";
import an02 from "@/assets/promotion/anning02.png";
import { getXzqhList, promotionFive, promotionLogin } from "@/api/common";

export default {
  name: "promotionList",
  data() {
    return {
      fiveData: [],
      fiveYear: "",
      monitorList: ["全部"],
      navigationIndex: 0,
      developData: true,
      developIcon: "el-icon-arrow-right",
      administration: [],
      administrationIndex: 0,
      administrationData: true,
      administrationIcon: "el-icon-arrow-right",
      listData: [],
      page: 1,
      rows: 6,
      total: 24,
      imgUrl: systemConfig.imgServer + systemConfig.imgApi,
      params: {
        county: "",
        year: "",
      },
      // 点击获取ID
      editId: "",
      loading: false,
    };
  },
  mounted() {
    var date = new Date();
    var year = date.getFullYear();
    this.provinceDate = year;
    for (let i = 2022; i <= year; i++) {
      this.monitorList.push(i);
    }
    // 获取土地推介专场
    this.getData();
    // 获取行政区划
    this.getDivision();
  },
  methods: {
    // 获取土地推介专场
    getData() {
      promotionFive().then((res) => {
        if (res.data.success) {
          this.fiveData = res.data.data.data;
          this.fiveYear = res.data.data.year;
        }
      });
    },
    // 获取行政区划
    getDivision() {
      getXzqhList().then((res) => {
        if (res.data.success) {
          this.administration = res.data.data[0].children;
          // console.log(this.administration);
          let obj = {
            id: null,
            label: "全部",
            level: "国家级",
            value: "",
            parkCount: 0,
            logogram: null,
          };
          this.administration.unshift(obj);
          this.params.county = res.data.data[0].children[0].value;
          // 获取往届土地推介专场
          this.getPromotionLogin();
        }
      });
    },
    // 获取往届土地推介专场
    getPromotionLogin() {
      this.loading = true;
      let data = this.params;
      data.size = this.rows;
      data.current = this.page;
      promotionLogin(data).then((res) => {
        this.loading = false;
        if (res.data.success) {
          this.total = res.data.data.total;
          this.listData = res.data.data.records;
          this.listData.forEach((item) => {
            if (!!item.file && item.file.length > 0) {
              item.file.forEach((fileItem) => {
                item.url = this.imgUrl + fileItem.filePath;
              });
            }
          });
        }
      });
    },
    // 数据为空验证
    testVerify(val) {
      if (!!val) {
        return val.name;
      }
    },
    // 返回图片地址
    imageAddress(val) {
      if (!!val) {
        if (!!val.file && val.file.length > 0) {
          console.log();
          return `${this.imgUrl}${val.file[0].filePath}`;
        }
      }
    },
    // 年份选择
    navigationSelect(index, item) {
      this.navigationIndex = index;
      if (item === "全部") {
        this.params.year = "";
      } else {
        this.params.year = item;
      }
      this.getPromotionLogin();
    },
    develop() {
      this.developData = !this.developData;
      if (this.developData) {
        this.developIcon = "el-icon-arrow-right";
      } else {
        this.developIcon = "el-icon-arrow-down";
      }
    },
    // 行政区划选择
    administrationSelect(index, item) {
      this.administrationIndex = index;
      this.params.county = item.value;
      this.getPromotionLogin();
    },
    administrationDevelop() {
      this.administrationData = !this.administrationData;
      if (this.administrationData) {
        this.administrationIcon = "el-icon-arrow-right";
      } else {
        this.administrationIcon = "el-icon-arrow-down";
      }
    },
    // 监听 pagesize 改变的事件
    handleSizeChange(newSize) {
      this.rows = newSize;
      this.getPromotionLogin();
    },
    // 监听 页码值 改变的事件
    handleCurrentChange(newPage) {
      this.page = newPage;
      this.getPromotionLogin();
    },
    // 跳转新窗口
    openCentralYunnan(item) {
      let name = item.templateId == 0 ? "centralYunnan" : "formWorkOne";

      if (!!item) {
        this.editId = item.id;
        const { href } = this.$router.resolve({
          name: name,
          query: {
            id: this.editId,
          },
        });
        window.open(href, "_blank");
      }
    },
  },
};
</script>
<style scoped>
.promotion-list {
  width: 60%;
  margin: 0 auto;
  background: #fff;
  /* padding: 10px 35px; */
  /*height: 600px;*/
  position: relative;
}

.promotion-top {
  padding: 10px 50px 50px 50px;
}
.title {
  font-weight: bold;
}
.line {
  display: flex;
  width: 35px;
  height: 4px;
  background: #386ed6;
  margin-top: 20px;
}
.card-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  cursor: pointer;
}
.card-top-left {
  width: calc(100% / 3 * 2);
  height: 260px;
  background: linear-gradient(
    160deg,
    rgba(63, 77, 201, 0.8),
    rgba(102, 180, 213, 0.4)
  );
  box-sizing: border-box;
  color: #ffffff;
  background-size: 100% 100%;
}
.card-top-right {
  width: calc(100% / 3 - 10px);
  height: 260px;
  margin-left: 20px;
  box-sizing: border-box;
  color: #ffffff;
  background: linear-gradient(
    160deg,
    rgba(63, 77, 201, 0.8),
    rgba(102, 180, 213, 0.4)
  );
  /*background-image: url("~@/assets/promotion/peaceful.png");*/
  background-size: 100% 100%;
}
.card-content-bottom {
  margin-top: 20px;
}
.card {
  position: relative;
  width: calc(100% / 3);
  height: 200px;
  margin-left: 20px;
  box-sizing: border-box;
  color: #ffffff;
  background: linear-gradient(
    160deg,
    rgba(63, 77, 201, 0.8),
    rgba(102, 180, 213, 0.4)
  );
}
.card:nth-child(1) {
  margin-left: 0;
}
.title-go {
  margin-top: 10px;
  display: block;
}
.promotion-bottom {
  background: #f6f6f6;
  padding: 10px 50px 20px 50px;
}
.monitor-content {
  background: #ffffff;
  margin-top: 20px;
  padding: 0 20px 20px 20px;
}
.monitor-year {
  display: flex;
  /*align-items: center;*/
  position: relative;
}
.year {
  width: 80px;
  height: 45px;
  line-height: 45px;
  padding-top: 10px;
}
.year-content {
  width: calc(100% - 110px);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  /*height: inherit;*/
  overflow: hidden;
}
.year-item {
  /*width: 50px;*/
  min-width: 50px;
  margin-left: 10px;
  padding: 2px 5px;
  border: 1px solid #e5e5e5;
  margin-top: 20px;
  color: #333333;
  font-size: 0.85rem;
  box-sizing: border-box;
  text-align: center;
  cursor: pointer;
  border-radius: 2px;
}
.filter {
  cursor: pointer;
  position: absolute;
  top: 24px;
  right: 0;
  margin-right: 0;
}
.navigation-select {
  border: none;
  background: #0a75da;
  color: #ffffff;
}
.develop-up {
  height: 100%;
}
.develop-away {
  height: 45px;
}
.list-content {
  display: flex;
  align-items: center;
  /* justify-content: space-between; */
  flex-wrap: wrap;
  background: #f6f6f6;
  padding: 0 50px;
}
.list-content-item {
  width: calc((100% - 60px) / 3);
  /*margin-left: 20px;*/
  background: #ffffff;
  /*height: 200px;*/
  /* margin-top: 20px; */
  margin: 20px 10px 0;
  box-shadow: inset 0 0 5px rgb(63 77 201 / 10%), 0 0 4px rgb(140 141 140 / 60%);
  border-radius: 4px;
  cursor: pointer;
}
/* .list-content-item:nth-child(1) {
  margin-left: 0;
} */
.img-content {
  width: 100%;
  height: 200px;
  /*background: linear-gradient(160deg, rgba(63,77,201,.8), rgba(102,180,213,.4));*/
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.line-name {
  font-size: 0.85rem;
  color: #333333;
  padding: 0 20px;
  height: 50px;
  line-height: 50px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.page-box {
  display: flex;
  padding: 50px 0;
  background: #f6f6f6;
  justify-content: center;
  align-items: center;
}
.el-pagination button:disabled {
  background: #386ed6;
  color: #ffffff;
  border-radius: 2px;
}
.el-pagination {
  background: #f6f6f6 !important;
}
.el-pager li.active {
  border: none;
  border-radius: 0;
  background: #386ed6;
  color: #ffffff;
}
.el-pager li {
  border: 1px solid #386ed6;
  color: #386ed6;
  margin-right: 10px;
}
.el-pager li:nth-child(1) {
  margin-left: 10px;
}
.el-pager li.active + li {
  border: 1px solid #386ed6;
}
.card-top {
  position: relative;
}
.card-title {
  position: absolute;
  left: 20px;
  top: 20px;
  z-index: 20;
}
.bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
  /* background: linear-gradient(
    160deg,
    rgba(63, 77, 201, 0.8),
    rgba(80, 120, 206, 0.8),
    rgba(102, 180, 213, 0.4)
  ); */
}
.park-list-table-no-c-img {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 50px;
  background: #fff;
}

.park-list-table-no-c-img > img {
  width: 30%;
}
</style>
